<template>
  <div>
    <div id="search-around-result-accordion" class="search-station-result-accordion" :style="getAccordionStyle()">
      <div class="ct-accordion" v-for="(sr, i) in aroundResultList" :key="sr.id"
           @click="showOnMap('kakao', '', sr)">
        <div class="ct-accordion-header">
          <div class="ct-accordion-title">
            <i class="bx bxs-map ct-padding-right-25"/>
            <span>{{ sr.place_name }}</span>
          </div>
          <div class="ct-accordion-content mt-1">
            <span :title="`${sr.address_name}`">- {{ $_utils.textLengthOverCut(sr.address_name, 26, '') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "evAroundResultList",
  props: {
    aroundResultList: Array,
  },
  data() {
    return {
    }
  },
  methods: {
    getAccordionStyle() {
      const vm = this;
      let height;

      if (this.$store.state.layout.browserMode === 'web') {
        height = { height: vm.detailSearchStationCheck ? 'calc(100vh - 516px)' : 'calc(100vh - 350px)' }
      } else {
        height = { height: vm.detailSearchStationCheck ? window.innerHeight - 580 + 'px' : window.innerHeight - 350 + 'px' }
      }

      return height;
    },
    showOnMap(type, subType, item) {
      const vm = this;

      this.$emit('showOnMap', type, subType, item);
    },
  }
}
</script>